import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, catchError, tap } from 'rxjs/operators';
import { SharedService } from './shared.service';

import { IAuthTokenResponse } from '../interfaces/auth-token-response';
import { IRestApiResponse } from '../interfaces/rest-api-response';

@Injectable({
  providedIn: 'root'
})
export class OtpValidationService {

  private otpGenerationUrl = '/mfa/otp-gen?odi={odi}'; 
  private otpVerificationUrl = '/mfa/otp-ver?otp={otp}'; 
  private otpAuthTokenRenewUrl = '/mfa/otp-token-renew'; 

  private http = inject(HttpClient);
  private sharedService = inject(SharedService);  

  constructor() { }

  public otpGenerate(otpDestinationId: string): Observable<any> {
    let url = this.sharedService.getAuthServerBaseUrl()
     + this.otpGenerationUrl.replace('{odi}', otpDestinationId);
    return this.http.post<any>(url, null, {responseType: 'json'})
    .pipe(
      tap(data => {
        // console.log('All: ' + JSON.stringify(data))
          // console.log('OtpValidationService - otpGenerate', data);
        }
      ),
      catchError(this.sharedService.handleError)
      // catchError(this.sharedService.handleError2<any>('otpGenerate'))
    ) 
  }

  public otpVerify(otpCode: string): Observable<IRestApiResponse> {
    let url = this.sharedService.getAuthServerBaseUrl()
     + this.otpVerificationUrl.replace('{otp}', otpCode);
    //  + "&test-resp-code=VERIFIED";  // FAILED | VERIFIED
    return this.http.post<IRestApiResponse>(url, null, {responseType: 'json'})
    .pipe(
      tap(data => {}
        // console.log('All: ' + JSON.stringify(data))
      ),
      catchError(this.sharedService.handleError)
      // catchError(this.sharedService.handleError2<any>('otpVerify'))
    ) 
  }

  public otpAuthTokenRenew(): Observable<IAuthTokenResponse> {
    let url = this.sharedService.getAuthServerBaseUrl() + this.otpAuthTokenRenewUrl;
    return this.http.post<IAuthTokenResponse>(url, null, {responseType: 'json'})
    .pipe(
      tap(data => {}
      ),
      catchError(this.sharedService.handleError)
      // catchError(this.sharedService.handleError2<any>('otpAuthTokenRenew'))
    ) 
  }

}
